// import React, { useState, useEffect, useRef } from "react";
// import moment from "moment";
// import airports from "../../Data/AirportList.json";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import Login from "../../Authentication/Login";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   RiCalendarLine,
//   RiFlightTakeoffLine,
//   RiFlightLandLine,
//   RiSearchLine,
// } from "react-icons/ri";

// const ModifyFlightSearch = ({ onSearch }) => {
//   const navigate = useNavigate();
//   const { user, loading } = useAuth();
//   const { state } = useLocation();
//   const [departureDate, setDepartureDate] = useState(new Date());
//   const [returnDate, setReturnDate] = useState(new Date());
//   const [departureResults, setDepartureResults] = useState([]);
//   const [arrivalResults, setArrivalResults] = useState([]);
//   const [locationFrom, setLocationFrom] = useState("HYD");
//   const [locationTo, setLocationTo] = useState("BOM");
//   const [displayFrom, setDisplayFrom] = useState("Hyderabad(HYD), India");
//   const [displayTo, setDisplayTo] = useState("Mumbai(BOM), India");
//   const [selectedDeparture, setSelectedDeparture] = useState(null);
//   const [selectedArrival, setSelectedArrival] = useState(null);
//   const [from, setFrom] = useState("Hyderabad, India");
//   const [to, setTo] = useState("Mumbai, India");
//   const [searchQuery, setSearchQuery] = useState({});
//   const [trips, setTrips] = useState([
//     {
//       from: "HYD, India",
//       to: "BOM, India",
//       locationFrom: "HYD",
//       locationTo: "BOM",
//       displayFrom: "Hyderabad(HYD)",
//       displayTo: "Mumbai(BOM)",
//       cityFrom: "Hyderabad",
//       cityTo: "Mumbai",
//       departureDate: new Date(),
//       departureResults: [],
//       arrivalResults: [],
//     },
//   ]);
//   const [adults, setAdults] = useState(1);
//   const [kids, setKids] = useState(0);
//   const [infants, setInfants] = useState(0);
//   const [cabinClass, setCabinClass] = useState("ECONOMY");
//   const [errors, setErrors] = useState({});
//   const [journeyType, setJourneyType] = useState("ONEWAY");
//   const inputDRef = useRef(null);
//   const inputARef = useRef(null);

//   // Custom input component for date picker (same as in your other components)
//   const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
//     <div className="input-group">
//       <input
//         type="text"
//         className="form-control"
//         value={value}
//         onClick={onClick}
//         ref={ref}
//         readOnly
//         placeholder="Select date"
//       />
//       <button className="btn btn-secondary" type="button" onClick={onClick}>
//         <RiCalendarLine />
//       </button>
//     </div>
//   ));

//   const validate = () => {
//     let temp = {};
//     temp.from = from === "" ? false : true;
//     temp.to = to === "" ? false : true;
//     setErrors(temp);
//     return Object.values(temp).every((x) => x === true);
//   };
//   const handleDepartureAirportSearch = (e) => {
//     const value = e.target.value;
//     setDisplayFrom(value);
//     if (value.length > 0) {
//       const lowerValue = value.toLowerCase();
//       const filteredAirports = airports
//         .filter(
//           (airport) =>
//             airport.display === true &&
//             airport.airportCode.toLowerCase().includes(value.toLowerCase())
//         )
//         .slice(0, 10);
//       setDepartureResults(filteredAirports);
//       if (filteredAirports.length === 0) {
//         const filteredAirports1 = airports
//           .filter(
//             (airport) =>
//               airport.airportCode.toLowerCase().includes(lowerValue) ||
//               airport.cityName.toLowerCase().includes(lowerValue) ||
//               (airport.airportName.toLowerCase().includes(lowerValue) &&
//                 (!selectedArrival ||
//                   airport.airportCode !== selectedArrival.airportCode)) // Exclude selected arrival
//           )
//           .slice(0, 10);
//         setDepartureResults(filteredAirports1);
//       }
//     } else {
//       setDepartureResults([]);
//     }
//   };
//   const handleDepartureAirportClick = (e) => {
//     setArrivalResults([]);
//     let filteredAirports = airports
//       .filter(function (p) {
//         return p.display === true;
//       })
//       .slice(0, 10);
//     setDepartureResults(filteredAirports);
//     inputDRef.current.select();
//   };
//   const handleDepartureSelect = (data) => {
//     if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
//       alert("Departure and arrival airports cannot be the same.");
//       setSelectedArrival(null);
//       setDisplayTo(""); // Clear arrival input
//       return;
//     } else {
//       var DF =
//         data.cityName + "(" + data.airportCode + "), " + data.countryName;
//       setDisplayFrom(DF);
//       setLocationFrom(data.airportCode);
//       setFrom(data.cityName);
//       setSelectedDeparture(data);
//       setDepartureResults([]);
//     }
//   };
//   const handleArrivalAirportSearch = (e) => {
//     const value = e.target.value;
//     setDisplayTo(value);
//     if (value.length > 0) {
//       const lowerValue = value.toLowerCase();
//       const filteredAirports = airports
//         .filter(
//           (airport) =>
//             airport.airportCode.toLowerCase().includes(lowerValue) ||
//             airport.cityName.toLowerCase().includes(lowerValue) ||
//             airport.airportName.toLowerCase().includes(lowerValue)
//         )
//         .slice(0, 10);
//       setArrivalResults(filteredAirports);
//       if (filteredAirports.length === 0) {
//         const filteredAirports1 = airports
//           .filter((airport) =>
//             airport.cityName.toLowerCase().includes(value.toLowerCase())
//           )
//           .slice(0, 10);
//         setArrivalResults(filteredAirports1);
//       }
//     } else {
//       setArrivalResults([]);
//     }
//   };
//   const handleArrivalSelect = (data) => {
//     if (
//       selectedDeparture &&
//       selectedDeparture.airportCode === data.airportCode
//     ) {
//       alert("Arrival and departure airports cannot be the same.");
//       setSelectedDeparture(null);
//       setDisplayFrom(""); // Clear departure input
//       return;
//     } else {
//       var DF =
//         data.cityName + "(" + data.airportCode + "), " + data.countryName;
//       setDisplayTo(DF);
//       setLocationTo(data.airportCode);
//       setTo(data.cityName);
//       setSelectedArrival(data);
//       setArrivalResults([]);
//     }
//   };
//   const handleArrivalAirportClick = (e) => {
//     setDepartureResults([]);
//     let filteredAirports = airports
//       .filter(function (p) {
//         return p.display === true;
//       })
//       .slice(0, 10);
//     setArrivalResults(filteredAirports);
//     inputARef.current.select();
//   };
//   const handleClassType = (e) => {
//     setCabinClass(e.target.value);
//   };
//   const handleIncreaseAdults = (e) => {
//     e.stopPropagation();
//     setAdults(parseFloat(adults + 1));
//   };
//   const handleDecreaseAdults = (e) => {
//     e.stopPropagation();
//     if (adults !== 1) {
//       setAdults(parseFloat(adults - 1));
//     }
//   };
//   const handleIncreaseKids = (e) => {
//     e.stopPropagation();
//     setKids(parseFloat(kids + 1));
//   };
//   const handleDecreaseKids = (e) => {
//     e.stopPropagation();
//     if (kids !== 0) {
//       setKids(parseFloat(kids - 1));
//     }
//   };
//   const handleIncreaseInfants = (e) => {
//     e.stopPropagation();
//     setInfants(parseFloat(infants + 1));
//   };
//   const handleDecreaseInfants = (e) => {
//     e.stopPropagation();
//     if (infants !== 0) {
//       setInfants(parseFloat(infants - 1));
//     }
//   };
//   const handleDepartureDate = (date) => {
//     const selectedDate = date;
//     setDepartureDate(selectedDate);

//     // If returnDate is before the new departureDate, reset it to departureDate
//     if (returnDate && selectedDate && returnDate < selectedDate) {
//       setReturnDate(selectedDate);
//     }
//   };
//   const handleReturnDate = (date) => {
//     setReturnDate(date);
//   };
//   const handleJourneyType = (e) => {
//     e.preventDefault();
//     setJourneyType(e.target.value);
//   };
//   function GetFlightDestinations() {
//     const fvalues = [];
//     for (var i = 0; i < trips.length; i++) {
//       fvalues.push({
//         from: locationFrom,
//         to: locationTo,
//         departureDate: moment(departureDate).format("YYYY-MM-DD"),
//         returnDate: moment(returnDate).format("YYYY-MM-DD"),
//       });
//     }
//     return fvalues;
//   }
//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (validate()) {
//       const searchQuery = {
//         journeyType: journeyType,
//         isDomestic: "DOMESTIC",
//         adults: adults,
//         kids: kids,
//         infants: infants,
//         cabinClass: cabinClass,
//         companyId: user?.isSupplierAPI === true ? user.cid : user.parentCompanyId,
//         preferred: "REGULAR",
//         isDirectFlight: false,
//         isConnectingFlight: false,
//         flightTravelerPoints: GetFlightDestinations(),
//       };
//       onSearch(searchQuery);
//       navigate(
//         "/flights/" + adults + "/" + kids + "/" + infants + "/DOMESTIC",
//         {
//           replace: true,
//           state: { searchQuery },
//         }
//       );
//     }
//   };
//   useEffect(() => {
//     console.log(state.searchQuery);
//     setSearchQuery(state.searchQuery);
//     setJourneyType(state.searchQuery.journeyType);
//     setCabinClass(state.searchQuery.cabinClass);
//     setAdults(state.searchQuery.adults);
//     setKids(state.searchQuery.kids);
//     setInfants(state.searchQuery.infants);
//     const dAirports = airports.find(
//       (c) => c.airportCode === state.searchQuery?.flightTravelerPoints[0]?.from
//     );
//     var DF =
//       dAirports?.cityName +
//       "(" +
//       dAirports?.airportCode +
//       "), " +
//       dAirports?.countryName;
//     setLocationFrom(dAirports?.airportCode);
//     setDisplayFrom(DF);
//     setFrom(dAirports?.cityName);
//     const rAirports = airports.find(
//       (c) => c.airportCode === state.searchQuery?.flightTravelerPoints[0]?.to
//     );
//     var DR =
//       rAirports?.cityName +
//       "(" +
//       rAirports?.airportCode +
//       "), " +
//       rAirports?.countryName;
//     setLocationTo(rAirports.airportCode);
//     setDisplayTo(DR);
//     setTo(rAirports.cityName);
//     setDepartureDate(
//       new Date(state.searchQuery?.flightTravelerPoints[0]?.departureDate)
//     );
//     setReturnDate(
//       new Date(state.searchQuery?.flightTravelerPoints[0]?.returnDate)
//     );
//   }, []);
//   if (loading) return <p>Loading...</p>;
//   if (!user) return <Login></Login>;
//   return (
//     <div className="card-body bg-dark text-white">
//       <div className="row">
//         <div style={{ width: "12%", paddingRight: "2px" }}>
//           <label htmlFor="iconInput" className="form-label">
//             Type
//           </label>
//           <select
//             className="form-select"
//             value={journeyType}
//             onChange={handleJourneyType}
//             name="journeyType"
//           >
//             <option value={"ONEWAY"}>ONEWAY</option>
//             <option value={"RETURN"}>ROUNDTRIP</option>
//           </select>
//         </div>
//         <div style={{ width: "15%", paddingRight: "2px", paddingLeft: "2px" }}>
//           <label htmlFor="iconInput" className="form-label">
//             FROM
//           </label>
//           <div className="form-icon position-relative">
//             <input
//               ref={inputDRef}
//               className="form-control form-control-icon"
//               type="text"
//               placeholder="Search for an airport"
//               value={displayFrom}
//               onChange={handleDepartureAirportSearch}
//               onClick={handleDepartureAirportClick}
//               onFocus={handleDepartureAirportClick}
//             />
//             <RiFlightTakeoffLine className="position-absolute top-50 end-0 translate-middle-y me-2" />
//           </div>
//           {errors.displayFrom === false ? (
//             <div className="validationerror">Please select departure </div>
//           ) : (
//             ""
//           )}
//           {departureResults.length > 0 && (
//             <ul
//               className="locationListVideo scrollable-list"
//               style={{ minWidth: "350px" }}
//             >
//               {departureResults.map((airport) => (
//                 <li
//                   className="locationListVideoItem"
//                   key={airport.airportCode}
//                   onClick={() => handleDepartureSelect(airport)}
//                 >
//                   <div className="item-name">
//                     {airport.cityName} ({airport.airportCode})
//                   </div>
//                   <div className="item-details">
//                     <span className="item-code-date">
//                       {airport.airportName},{" "}
//                     </span>
//                     <span className="item-designation">
//                       {airport.countryName}
//                     </span>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//         <div style={{ width: "15%", paddingRight: "2px", paddingLeft: "2px" }}>
//           <label htmlFor="iconInput" className="form-label">
//             TO
//           </label>
//           <div className="form-icon position-relative">
//             <input
//               ref={inputARef}
//               className="form-control searchTextbox"
//               type="text"
//               placeholder="Search for an airport"
//               value={displayTo}
//               onChange={handleArrivalAirportSearch}
//               onClick={handleArrivalAirportClick}
//               onFocus={handleArrivalAirportClick}
//             />
//             <RiFlightLandLine className="position-absolute top-50 end-0 translate-middle-y me-2" />
//           </div>
//           {arrivalResults.length > 0 && (
//             <ul
//               className="locationListVideo scrollable-list"
//               style={{ minWidth: "350px" }}
//             >
//               {arrivalResults.map((airport) => (
//                 <li
//                   className="locationListVideoItem"
//                   key={airport.airportCode}
//                   onClick={() => handleArrivalSelect(airport)}
//                 >
//                   <div className="item-name">
//                     {airport.cityName} ({airport.airportCode})
//                   </div>
//                   <div className="item-details">
//                     <span className="item-code-date">
//                       {airport.airportName}
//                     </span>
//                     <span className="item-designation">
//                       {airport.countryName}
//                     </span>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>
//         <div style={{ width: "13%", paddingRight: "2px", paddingLeft: "2px" }}>
//           <label htmlFor="iconInput" className="form-label">
//             DEPARTURE DATE
//           </label>
//           <DatePicker
//             selected={departureDate}
//             onChange={handleDepartureDate}
//             customInput={<CustomDateInput />}
//             dateFormat="dd-MMM-yyyy"
//             showYearDropdown
//             showMonthDropdown
//             dropdownMode="select"
//             minDate={new Date()}
//             yearDropdownItemNumber={50}
//             scrollableYearDropdown
//             className="form-control"
//             placeholder="DEPARTURE DATE"
//           />
//         </div>
//         {journeyType === "RETURN" ? (
//           <div
//             style={{ width: "13%", paddingRight: "2px", paddingLeft: "2px" }}
//           >
//             <label htmlFor="iconInput" className="form-label">
//               RETURN DATE
//             </label>
//             <DatePicker
//               selected={returnDate}
//               onChange={handleReturnDate}
//               customInput={<CustomDateInput />}
//               dateFormat="dd-MMM-yyyy"
//               showYearDropdown
//               showMonthDropdown
//               dropdownMode="select"
//               minDate={departureDate}
//               yearDropdownItemNumber={50}
//               scrollableYearDropdown
//               className="form-control"
//               placeholder="RETURN DATE"
//             />
//           </div>
//         ) : (
//           ""
//         )}
//         <div style={{ width: "24%", paddingRight: "2px", paddingLeft: "2px" }}>
//           <label htmlFor="iconInput" className="form-label">
//             TRAVELLERS & CLASS
//           </label>
//           <div class="dropdown" data-bs-auto-close="outside">
//             <div
//               class=" form-control w-100 dropdown-toggle"
//               type="button"
//               id="dropdownMenuButton"
//               data-bs-toggle="dropdown"
//               aria-expanded="false"
//             >
//               {adults +
//                 " Adults, " +
//                 kids +
//                 " Kids, " +
//                 infants +
//                 " Infants & " +
//                 cabinClass}
//             </div>
//             <div
//               className="dropdown-menu p-3"
//               aria-labelledby="dropdownMenuButton"
//             >
//               <div className="mb-3 d-flex justify-content-between align-items-center">
//                 <span>Adults</span>
//                 <div className="input-step d-flex align-items-center">
//                   <button
//                     type="button"
//                     className="minus"
//                     onClick={handleDecreaseAdults}
//                   >
//                     –
//                   </button>
//                   <input
//                     type="number"
//                     className="product-quantity text-center"
//                     min="1"
//                     max="9"
//                     readOnly
//                     value={adults}
//                     name="adults"
//                   />
//                   <button
//                     type="button"
//                     className="plus"
//                     onClick={handleIncreaseAdults}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>
//               <div className="mb-3 d-flex justify-content-between align-items-center">
//                 <span>Kids</span>
//                 <div className="input-step d-flex align-items-center">
//                   <button
//                     type="button"
//                     className="minus"
//                     onClick={handleDecreaseKids}
//                   >
//                     –
//                   </button>
//                   <input
//                     type="number"
//                     className="product-quantity text-center"
//                     min="0"
//                     max="9"
//                     readOnly
//                     value={kids}
//                     name="kids"
//                   />
//                   <button
//                     type="button"
//                     className="plus"
//                     onClick={handleIncreaseKids}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>
//               <div className="mb-3 d-flex justify-content-between align-items-center">
//                 <span>Infants</span>
//                 <div className="input-step d-flex align-items-center">
//                   <button
//                     type="button"
//                     className="minus"
//                     onClick={handleDecreaseInfants}
//                   >
//                     –
//                   </button>
//                   <input
//                     type="number"
//                     className="product-quantity text-center"
//                     min="0"
//                     max="5"
//                     readOnly
//                     value={infants}
//                     name="infants"
//                   />
//                   <button
//                     type="button"
//                     className="plus"
//                     onClick={handleIncreaseInfants}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>
//               <div className="mb-3 d-flex justify-content-between align-items-center">
//                 <div class="form-check form-check-inline">
//                   <input
//                     class="form-check-input"
//                     type="radio"
//                     name="cabinClass"
//                     id="ECONOMY"
//                     onChange={(e) => handleClassType(e)}
//                     value="ECONOMY"
//                     checked={cabinClass === "ECONOMY" ? true : false}
//                   ></input>
//                   <label class="form-check-label" for="inlineRadio1">
//                     REGULAR
//                   </label>
//                 </div>
//                 <div class="form-check form-check-inline">
//                   <input
//                     class="form-check-input"
//                     type="radio"
//                     name="cabinClass"
//                     id="BUSINESS"
//                     onChange={(e) => handleClassType(e)}
//                     value="BUSINESS"
//                     checked={cabinClass === "BUSINESS" ? true : false}
//                   ></input>
//                   <label class="form-check-label" for="inlineRadio2">
//                     BUSINESS
//                   </label>
//                 </div>
//               </div>
//               <div className="mb-3 d-flex justify-content-between align-items-center">
//                 <div class="form-check form-check-inline">
//                   <input
//                     class="form-check-input"
//                     type="radio"
//                     name="cabinClass"
//                     id="FIRST"
//                     onChange={(e) => handleClassType(e)}
//                     value="ECONOMY"
//                     checked={cabinClass === "FIRST" ? true : false}
//                   ></input>
//                   <label class="form-check-label" for="inlineRadio2">
//                     FIRST
//                   </label>
//                 </div>
//                 <div class="form-check form-check-inline">
//                   <input
//                     class="form-check-input"
//                     type="radio"
//                     name="cabinClass"
//                     id="PREMIUM_ECONOMY"
//                     onChange={(e) => handleClassType(e)}
//                     value="PREMIUM_ECONOMY"
//                     checked={cabinClass === "PREMIUM_ECONOMY" ? true : false}
//                   ></input>
//                   <label class="form-check-label" for="inlineRadio2">
//                     PREMIUM ECONOMY
//                   </label>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div style={{ width: "8%", paddingRight: "2px", paddingLeft: "2px" }}>
//           <button
//             type="button"
//             onClick={handleSearch}
//             className="w-100 btn btn-danger"
//             style={{ marginTop: "28px" }}
//           >
//             <RiSearchLine className="align-middle me-2" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ModifyFlightSearch;
import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import airports from "../../Data/AirportList.json";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  RiCalendarLine,
  RiFlightTakeoffLine,
  RiFlightLandLine,
  RiSearchLine,
} from "react-icons/ri";
import "./ModifyFlightSearch.css";

const ModifyFlightSearch = ({ onSearch, initialSearchQuery }) => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { state } = useLocation();
  
  // Original state management exactly as in ModifyFlightSearch
  const [departureDate, setDepartureDate] = useState(new Date());
  const [returnDate, setReturnDate] = useState(new Date());
  const [departureResults, setDepartureResults] = useState([]);
  const [arrivalResults, setArrivalResults] = useState([]);
  const [locationFrom, setLocationFrom] = useState("HYD");
  const [locationTo, setLocationTo] = useState("BOM");
  const [displayFrom, setDisplayFrom] = useState("Hyderabad(HYD), India");
  const [displayTo, setDisplayTo] = useState("Mumbai(BOM), India");
  const [selectedDeparture, setSelectedDeparture] = useState(null);
  const [selectedArrival, setSelectedArrival] = useState(null);
  const [from, setFrom] = useState("Hyderabad, India");
  const [to, setTo] = useState("Mumbai, India");
  const [searchQuery, setSearchQuery] = useState({});
  const [trips, setTrips] = useState([
    {
      from: "HYD, India",
      to: "BOM, India",
      locationFrom: "HYD",
      locationTo: "BOM",
      displayFrom: "Hyderabad(HYD)",
      displayTo: "Mumbai(BOM)",
      cityFrom: "Hyderabad",
      cityTo: "Mumbai",
      departureDate: new Date(),
      departureResults: [],
      arrivalResults: [],
    },
  ]);
  const [adults, setAdults] = useState(1);
  const [kids, setKids] = useState(0);
  const [infants, setInfants] = useState(0);
  const [cabinClass, setCabinClass] = useState("ECONOMY");
  const [errors, setErrors] = useState({});
  const [journeyType, setJourneyType] = useState("ONEWAY");
  
  // Refs for new UI
  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);
  const fromDropdownRef = useRef(null);
  const toDropdownRef = useRef(null);

  // Custom date input component
  const CustomDateInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
    <div className="sf1-modify-input-group">
      <input
        type="text"
        className="sf1-modify-form-control"
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        placeholder={placeholder || "Select date"}
      />
      <button className="sf1-modify-btn-secondary" type="button" onClick={onClick}>
        <RiCalendarLine />
      </button>
    </div>
  ));

  // Original validate function
  const validate = () => {
    let temp = {};
    temp.from = from === "" ? false : true;
    temp.to = to === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  // Original airport search functions
  const handleDepartureAirportSearch = (e) => {
    const value = e.target.value;
    setDisplayFrom(value);
    if (value.length > 0) {
      const lowerValue = value.toLowerCase();
      const filteredAirports = airports
        .filter(
          (airport) =>
            airport.display === true &&
            airport.airportCode.toLowerCase().includes(value.toLowerCase())
        )
        .slice(0, 10);
      setDepartureResults(filteredAirports);
      if (filteredAirports.length === 0) {
        const filteredAirports1 = airports
          .filter(
            (airport) =>
              airport.airportCode.toLowerCase().includes(lowerValue) ||
              airport.cityName.toLowerCase().includes(lowerValue) ||
              (airport.airportName.toLowerCase().includes(lowerValue) &&
                (!selectedArrival ||
                  airport.airportCode !== selectedArrival.airportCode))
          )
          .slice(0, 10);
        setDepartureResults(filteredAirports1);
      }
    } else {
      setDepartureResults([]);
    }
  };

  const handleDepartureAirportClick = (e) => {
    setArrivalResults([]);
    let filteredAirports = airports
      .filter(function (p) {
        return p.display === true;
      })
      .slice(0, 10);
    setDepartureResults(filteredAirports);
    fromInputRef.current.select();
  };

  const handleDepartureSelect = (data) => {
    if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
      alert("Departure and arrival airports cannot be the same.");
      setSelectedArrival(null);
      setDisplayTo("");
      return;
    } else {
      var DF =
        data.cityName + "(" + data.airportCode + "), " + data.countryName;
      setDisplayFrom(DF);
      setLocationFrom(data.airportCode);
      setFrom(data.cityName);
      setSelectedDeparture(data);
      setDepartureResults([]);
    }
  };

  const handleArrivalAirportSearch = (e) => {
    const value = e.target.value;
    setDisplayTo(value);
    if (value.length > 0) {
      const lowerValue = value.toLowerCase();
      const filteredAirports = airports
        .filter(
          (airport) =>
            airport.airportCode.toLowerCase().includes(lowerValue) ||
            airport.cityName.toLowerCase().includes(lowerValue) ||
            airport.airportName.toLowerCase().includes(lowerValue)
        )
        .slice(0, 10);
      setArrivalResults(filteredAirports);
      if (filteredAirports.length === 0) {
        const filteredAirports1 = airports
          .filter((airport) =>
            airport.cityName.toLowerCase().includes(value.toLowerCase())
          )
          .slice(0, 10);
        setArrivalResults(filteredAirports1);
      }
    } else {
      setArrivalResults([]);
    }
  };

  const handleArrivalSelect = (data) => {
    if (
      selectedDeparture &&
      selectedDeparture.airportCode === data.airportCode
    ) {
      alert("Arrival and departure airports cannot be the same.");
      setSelectedDeparture(null);
      setDisplayFrom("");
      return;
    } else {
      var DF =
        data.cityName + "(" + data.airportCode + "), " + data.countryName;
      setDisplayTo(DF);
      setLocationTo(data.airportCode);
      setTo(data.cityName);
      setSelectedArrival(data);
      setArrivalResults([]);
    }
  };

  const handleArrivalAirportClick = (e) => {
    setDepartureResults([]);
    let filteredAirports = airports
      .filter(function (p) {
        return p.display === true;
      })
      .slice(0, 10);
    setArrivalResults(filteredAirports);
    toInputRef.current.select();
  };

  // Original passenger handlers
  const handleClassType = (e) => {
    setCabinClass(e.target.value);
  };

  const handleIncreaseAdults = (e) => {
    e.stopPropagation();
    setAdults(parseFloat(adults + 1));
  };

  const handleDecreaseAdults = (e) => {
    e.stopPropagation();
    if (adults !== 1) {
      setAdults(parseFloat(adults - 1));
    }
  };

  const handleIncreaseKids = (e) => {
    e.stopPropagation();
    setKids(parseFloat(kids + 1));
  };

  const handleDecreaseKids = (e) => {
    e.stopPropagation();
    if (kids !== 0) {
      setKids(parseFloat(kids - 1));
    }
  };

  const handleIncreaseInfants = (e) => {
    e.stopPropagation();
    setInfants(parseFloat(infants + 1));
  };

  const handleDecreaseInfants = (e) => {
    e.stopPropagation();
    if (infants !== 0) {
      setInfants(parseFloat(infants - 1));
    }
  };

  const handleDepartureDateChange = (date) => {
    const selectedDate = date;
    setDepartureDate(selectedDate);
    if (returnDate && selectedDate && returnDate < selectedDate) {
      setReturnDate(selectedDate);
    }
  };

  const handleReturnDateChange = (date) => {
    setReturnDate(date);
  };

  const handleJourneyType = (e) => {
    e.preventDefault();
    setJourneyType(e.target.value);
  };

  // Fixed GetFlightDestinations function
  function GetFlightDestinations() {
    const fvalues = [];
    for (var i = 0; i < trips.length; i++) {
      fvalues.push({
        from: locationFrom,
        to: locationTo,
        departureDate: moment(departureDate).format("YYYY-MM-DD"),
        returnDate: journeyType === "RETURN" ? moment(returnDate).format("YYYY-MM-DD") : null,
      });
    }
    return fvalues;
  }

  // Updated handleSearch - REMOVED navigation, only calls onSearch
  const handleSearch = (e) => {
    e.preventDefault();
    if (validate()) {
      const searchQuery = {
        journeyType: journeyType,
        isDomestic: "DOMESTIC",
        adults: adults,
        kids: kids,
        infants: infants,
        cabinClass: cabinClass,
        companyId: user?.isSupplierAPI === true ? user.cid : user.parentCompanyId,
        preferred: "REGULAR",
        isDirectFlight: false,
        isConnectingFlight: false,
        flightTravelerPoints: GetFlightDestinations(),
      };
      console.log("Modify Search Query:", searchQuery);
      
      // Call the onSearch prop from parent component
      if (onSearch) {
        onSearch(searchQuery);
      }
    }
  };

  // Original useEffect to initialize form with search query data
  useEffect(() => {
    const queryToUse = state?.searchQuery || initialSearchQuery;
    
    if (queryToUse) {
      console.log("Initializing with query:", queryToUse);
      setSearchQuery(queryToUse);
      setJourneyType(queryToUse.journeyType);
      setCabinClass(queryToUse.cabinClass);
      setAdults(queryToUse.adults || 1);
      setKids(queryToUse.kids || 0);
      setInfants(queryToUse.infants || 0);
      
      const dAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.from
      );
      if (dAirports) {
        var DF =
          dAirports?.cityName +
          "(" +
          dAirports?.airportCode +
          "), " +
          dAirports?.countryName;
        setLocationFrom(dAirports?.airportCode);
        setDisplayFrom(DF);
        setFrom(dAirports?.cityName);
        setSelectedDeparture(dAirports);
      }
      
      const rAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.to
      );
      if (rAirports) {
        var DR =
          rAirports?.cityName +
          "(" +
          rAirports?.airportCode +
          "), " +
          rAirports?.countryName;
        setLocationTo(rAirports.airportCode);
        setDisplayTo(DR);
        setTo(rAirports.cityName);
        setSelectedArrival(rAirports);
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.departureDate) {
        setDepartureDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.departureDate)
        );
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.returnDate) {
        setReturnDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.returnDate)
        );
      }
    }
  }, [state, initialSearchQuery]);

  // NEW useEffect to update when initialSearchQuery changes from parent
  useEffect(() => {
    // This effect will run when initialSearchQuery changes
    const queryToUse = initialSearchQuery;
    
    if (queryToUse) {
      console.log("Updating form with new query:", queryToUse);
      setJourneyType(queryToUse.journeyType);
      setCabinClass(queryToUse.cabinClass);
      setAdults(queryToUse.adults || 1);
      setKids(queryToUse.kids || 0);
      setInfants(queryToUse.infants || 0);
      
      const dAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.from
      );
      if (dAirports) {
        var DF =
          dAirports?.cityName +
          "(" +
          dAirports?.airportCode +
          "), " +
          dAirports?.countryName;
        setLocationFrom(dAirports?.airportCode);
        setDisplayFrom(DF);
        setFrom(dAirports?.cityName);
        setSelectedDeparture(dAirports);
      }
      
      const rAirports = airports.find(
        (c) => c.airportCode === queryToUse?.flightTravelerPoints?.[0]?.to
      );
      if (rAirports) {
        var DR =
          rAirports?.cityName +
          "(" +
          rAirports?.airportCode +
          "), " +
          rAirports?.countryName;
        setLocationTo(rAirports.airportCode);
        setDisplayTo(DR);
        setTo(rAirports.cityName);
        setSelectedArrival(rAirports);
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.departureDate) {
        setDepartureDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.departureDate)
        );
      }
      
      if (queryToUse?.flightTravelerPoints?.[0]?.returnDate) {
        setReturnDate(
          new Date(queryToUse?.flightTravelerPoints?.[0]?.returnDate)
        );
      }
    }
  }, [initialSearchQuery]); // This dependency is key

  // Get passenger display text for new UI
  const getPassengerDisplay = () => {
    return `${adults} Adult${adults !== 1 ? 's' : ''}${
      kids > 0 ? `, ${kids} Kid${kids !== 1 ? 's' : ''}` : ''
    }${
      infants > 0 ? `, ${infants} Infant${infants !== 1 ? 's' : ''}` : ''
    } & ${cabinClass}`;
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fromDropdownRef.current && !fromDropdownRef.current.contains(event.target) && 
          fromInputRef.current && !fromInputRef.current.contains(event.target)) {
        setDepartureResults([]);
      }
      
      if (toDropdownRef.current && !toDropdownRef.current.contains(event.target) && 
          toInputRef.current && !toInputRef.current.contains(event.target)) {
        setArrivalResults([]);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!user) return null;

  return (
    <div className="sf1-modify-search-card">
      <div className="sf1-modify-search-row">
        {/* Journey Type Selector */}
        <div className="sf1-modify-field">
          <label>Type</label>
          <select 
            className="sf1-modify-select" 
            value={journeyType} 
            onChange={handleJourneyType}
          >
            <option value="ONEWAY">ONEWAY</option>
            <option value="RETURN">ROUNDTRIP</option>
          </select>
        </div>

        {/* From Field */}
        <div className="sf1-modify-field">
          <label>From</label>
          <div className="sf1-modify-input-with-icon">
            <input
              ref={fromInputRef}
              type="text"
              value={displayFrom}
              onChange={handleDepartureAirportSearch}
              onFocus={handleDepartureAirportClick}
              onClick={handleDepartureAirportClick}
              placeholder="Search for an airport"
              autoComplete="off"
            />
          </div>
          {departureResults.length > 0 && (
            <ul className="sf1-modify-airport-dropdown" ref={fromDropdownRef}>
              {departureResults.map((airport) => (
                <li
                  key={airport.airportCode}
                  className="sf1-modify-airport-item"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleDepartureSelect(airport);
                  }}
                >
                  <div className="sf1-modify-airport-name">
                    {airport.cityName} ({airport.airportCode})
                  </div>
                  <div className="sf1-modify-airport-details">
                    {airport.airportName}, {airport.countryName}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* To Field */}
        <div className="sf1-modify-field">
          <label>To</label>
          <div className="sf1-modify-input-with-icon">
            <input
              ref={toInputRef}
              type="text"
              value={displayTo}
              onChange={handleArrivalAirportSearch}
              onFocus={handleArrivalAirportClick}
              onClick={handleArrivalAirportClick}
              placeholder="Search for an airport"
              autoComplete="off"
            />
          </div>
          {arrivalResults.length > 0 && (
            <ul className="sf1-modify-airport-dropdown" ref={toDropdownRef}>
              {arrivalResults.map((airport) => (
                <li
                  key={airport.airportCode}
                  className="sf1-modify-airport-item"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleArrivalSelect(airport);
                  }}
                >
                  <div className="sf1-modify-airport-name">
                    {airport.cityName} ({airport.airportCode})
                  </div>
                  <div className="sf1-modify-airport-details">
                    {airport.airportName}, {airport.countryName}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Departure Date */}
        <div className="sf1-modify-field">
          <label>Depart</label>
          <DatePicker
            selected={departureDate}
            onChange={handleDepartureDateChange}
            customInput={<CustomDateInput placeholder="Departure Date" />}
            dateFormat="dd MMM yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            minDate={new Date()}
            yearDropdownItemNumber={50}
            scrollableYearDropdown
          />
        </div>

        {/* Return Date (for roundtrip) */}
        {journeyType === "RETURN" && (
          <div className="sf1-modify-field">
            <label>Return</label>
            <DatePicker
              selected={returnDate}
              onChange={handleReturnDateChange}
              customInput={<CustomDateInput placeholder="Return Date" />}
              dateFormat="dd MMM yyyy"
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              minDate={departureDate}
              yearDropdownItemNumber={50}
              scrollableYearDropdown
            />
          </div>
        )}

        {/* Travellers & Class Dropdown */}
        <div className="sf1-modify-field">
          <label>Travellers</label>
          <div className="sf1-modify-passenger-dropdown-container">
            <div className="sf1-modify-passenger-select">
              {getPassengerDisplay()}
            </div>
            
            <div className="sf1-modify-passenger-controls">
              <div className="sf1-modify-passenger-row">
                <span>Adults</span>
                <div className="sf1-modify-input-step">
                  <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseAdults}>-</button>
                  <span className="sf1-modify-step-value">{adults}</span>
                  <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseAdults}>+</button>
                </div>
              </div>
              <div className="sf1-modify-passenger-row">
                <span>Kids</span>
                <div className="sf1-modify-input-step">
                  <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseKids}>-</button>
                  <span className="sf1-modify-step-value">{kids}</span>
                  <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseKids}>+</button>
                </div>
              </div>
              <div className="sf1-modify-passenger-row">
                <span>Infants</span>
                <div className="sf1-modify-input-step">
                  <button type="button" className="sf1-modify-step-btn" onClick={handleDecreaseInfants}>-</button>
                  <span className="sf1-modify-step-value">{infants}</span>
                  <button type="button" className="sf1-modify-step-btn" onClick={handleIncreaseInfants}>+</button>
                </div>
              </div>
              <div className="sf1-modify-cabin-options">
                <div className="sf1-modify-cabin-row">
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="ECONOMY"
                      checked={cabinClass === "ECONOMY"}
                      onChange={handleClassType}
                    />
                    ECONOMY
                  </label>
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="BUSINESS"
                      checked={cabinClass === "BUSINESS"}
                      onChange={handleClassType}
                    />
                    BUSINESS
                  </label>
                </div>
                <div className="sf1-modify-cabin-row">
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="FIRST"
                      checked={cabinClass === "FIRST"}
                      onChange={handleClassType}
                    />
                    FIRST
                  </label>
                  <label className="sf1-modify-cabin-check">
                    <input
                      type="radio"
                      name="cabinClass"
                      value="PREMIUM_ECONOMY"
                      checked={cabinClass === "PREMIUM_ECONOMY"}
                      onChange={handleClassType}
                    />
                    PREMIUM ECONOMY
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search Button */}
        <button type="button" className="sf1-modify-search-btn" onClick={handleSearch}>
          <RiSearchLine className="sf1-modify-search-icon" />
        </button>
      </div>
    </div>
  );
};

export default ModifyFlightSearch;